export const ACTIONS = {
  ADD: 'add',
  EDIT: 'edit',
  DELETE: 'delete',
  CLOSED: 'closed',
  ALL: 'all',
} as const;

export const { ADD, EDIT, CLOSED, ALL } = ACTIONS;

export const RECIPIENT_BADGE_VARIANT = {
  PILL: 'pill',
  TAG: 'tag',
} as const;

export type RecipientBadgesVariant =
  (typeof RECIPIENT_BADGE_VARIANT)[keyof typeof RECIPIENT_BADGE_VARIANT];
